import { render, staticRenderFns } from "./zhuanti-shuangtan.vue?vue&type=template&id=1e1dc0ea&"
import script from "./zhuanti-shuangtan.vue?vue&type=script&lang=js&"
export * from "./zhuanti-shuangtan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports